import React from 'react';
import { string } from 'prop-types';
import Icon from './Icon';

export default function Check({ fill, ...props }) {
    return (
        <Icon {...props} viewBox="2 2 11 11">
            <path d="M10.8 3.4L6 8.1 4.3 6.3 2.5 8.1 6 11.6l6.5-6.5z" />
        </Icon>
    );
}

Check.propTypes = {
    fill: string,
};

Check.defaultProps = {
    fill: '#fff',
};
